import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

// 供应商协同，供应商门户模块api
class Supplier {

    //-----------------------------收到的采购订单相关---------------------------------//

    //INTF-00364：对选中的采购订单，进行计划提交
    batchSubmitPoHeaderList(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/BatchSubmitPoHeaderList`, body);
    }

    //INTF-00424: 获取采购订单头id下所有有效订单行的所有收货地址
    async getReceiveAddressListByPoId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/GetReceiveInfoByPOHeaderId`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.receive_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get receive address list by po failed: INTF-00424", err);
            return { err: true, msg: err.response.data };
        }
    }

    //-----------------------------------------交货单ASN头相关---------------------------------//

    //INTF-00059：对新建的交货单头进行保存
    addAsnHeader(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/CreateOne`, body);
    }

    //INTF-00060：对选中的草稿交货单头进行批量删除
    batchDeleteAsnHeader(arr) {
        let body = { id_arr: arr };
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/Delete`, body);
    }

    //INTF-00061：对已有的交货单头进行修改保存
    updateAsnHeader(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/UpdateAsnHeader`, body);
    }

    //INTF-00062：获取分页的交货单列表
    async getAsnHeaderList(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_asn_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get asn header list in pages failed: INTF-00062", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00518：获取分页的所有用户的交货单列表
    getAsnHeaderListAll(query, route) {
        let body = { types: 'object,object', values: [{ is_all: true, query: query }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierTeamworkProvider/FindAll`, body);
    }

    //INTF-00350：根据请求的采购订单行id，获得其关联且已发货的asn头列表，不分页
    async getAsnHeadersByPoLineId(poLineId) {
        let body = { id: poLineId };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/GetAsnInfosByPoline`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_asn_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get asn headers by po line id failed: INTF-00350", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00352：根据ASN头的ID，获取该头的详细信息
    getAsnHeaderDetailById(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/FindOne`, body);
    }

    //INTF-00806：按ASN公开流水号查单据头信息（扫描收货备用入口：人工按单号搜单）
    async getAsnHeaderByNum(asnNum) {
        let body = { id: asnNum };
        try {
            return await axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/FindOneByNum`, body);
        } catch (err) {
            console.log('get asn header by asn_num failed: INTF-00806', err);
            return { err: true, msg: err.response ? err.response.data : err.message };
        }
    }

    //INTF-00804：按ASN公开流水号查详情（含明细行+每行箱号区间，扫描收货锁单用）
    async getAsnDetailByNum(asnNum) {
        let body = { id: asnNum };
        try {
            return await axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/FindAsnDetailByAsnNum`, body);
        } catch (err) {
            console.log('get asn detail by asn_num failed: INTF-00804', err);
            return { err: true, msg: err.response ? err.response.data : err.message };
        }
    }


    //INTF-00353：对发货单进行发货操作
    batchSendAsnHeader(arr) {
        let body = { id_arr: arr };
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/BatchSendAsnHeader`, body);
    }

    //INTF-00354：对发货单头进行生失效设置
    batchDisableOrEnableAsnHeader(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/UpdateActived`, body);
    }

    //INTF-00425：查询发货单头关联的移动单列表
    getMoveHeadersRelatedAsnHeader(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/FindByAsnId`, body);
    }


    //INTF-00435：撤回已发的发货单
    cancelAsnHeader(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/RollBackAsnHeader`, body);
    }


    //INTF-00438：分页查询，获取未被使用的ASN单头列表。x用于区分是否所有用户的内容（true所有，false仅当前用户）
    async getUnusedAsnHeaders(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/FindAllByIsUsed`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_asn_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get unused asn headers list in pages failed: INTF-00438", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-XXXXX：下载交货单的附件，暂时不用
    getDownUploadFileUrlById(moduleName, hid, route) {
        let body = { types: "object,object", values: [{ moduleName: moduleName, parameter: hid + "" }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.FileSupplierTeamworkProvider/ReadTemplateDownUploadFile`, body);
    }

    //--------------------------交货单行相关---------------------------//

    //INTF-00348：在交货单头下，对一坨交货单行进行更新
    updateSendLinesById(arr, id, delids) {
        let body = { supplier_asn_line_infos: arr, deleted_ids: delids, header_id: id };
        return axios.post(`/mySupplierApp/service.SupplierAsnLineProvider/UpdateDetails`, body);
    }

    //INTF-00351：在交货单头下，获取分页的交货单行列表
    async getSendLinesByAsnHeaderId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierAsnLineProvider/FindAllByHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_asn_line_infos = [];
                res.total;
            }
            return res;
        } catch (err) {
            console.log("get asn lines in no pages failed: INTF-00351", err);
            return { err: true, msg: err.response.data };
        }
    }


    /*INTF-00355：前端提供供应商编号，返回该供应商接收到的所有采购订单行信息列表，分页
    getPoLineListBySupplier(numStr, ids, query, route) {
        let body = { types: "object,object", values: [{ supplier_id: numStr, pol_ids: ids }, query, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierTeamworkSendLineProvider/GetPoLineListBySupplierId`, body);
    }
    */

    //INTF-00423：根据头信息中的发货单头，返回尚未被该发货单头所使用的，且符合发货单头中地址及接收人的采购订单行列表，分页
    async getPoLineListBySTID(asn_id, ids, query) {
        let body = { asn_id: asn_id, po_line_ids: ids, query: query };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierAsnLineProvider/FindAllPoLines`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get po lines not in asn by asn failed: INTF-00423", err);
            return { err: true, msg: err.response.data };
        }
    }


    //-----------对账通知相关----------------------------------------------------------------//
    //------------------对账通知单头相关---------------------------------------//
    //INTF-00078：对新建的对账单头进行保存
    addNewReconcilationHeader(val, route) {
        let body = { types: "object,object", values: [{ info: val }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/CreateNoticeHeader`, body);
    }

    //INTF-00079：删除选中的对账单头
    batchDeleteBillHeader(arr, route) {
        let body = { types: "object,object", values: [{ ids: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/DeleteNoticeHeaderByIds`, body);
    }

    //INTF-00080:对修改的对账单头进行保存
    updateReconcilationHeader(val, route) {
        let body = { types: "object,object", values: [{ info: val }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/UpdateNoticeHeader`, body);
    }

    //INTF-00081：分页查询获取对账通知单头列表信息
    getReconciliationHeaderList(query, route) {
        let body = { types: "object,object", values: [{ query: query }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/FindAllNoticeHeader`, body);
    }

    //INTF-00539: 供应商---查询自己创建的--没有被票据单引用的对账单头
    getAllNoticeHeaderByNoBillQuote(query, route) {
        let body = { types: "object,object", values: [{ query: query }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/FindAllHeaderByNoBillQuote`, body);
    }

    //INTF-00345：队选中的对账单头进行生失效设置
    batchDisableOrEnableBillHeader(arr, x, route) {
        let body = { types: "object,object", values: [{ ids: arr, is_active: x }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/UpdataNoticeHeaderIsActive`, body);
    }

    //INTF-00360：根据ID获取对账单头信息
    getReconciliationHeaderDetailById(id, route) {
        let body = { types: "object,object", values: [{ id: id }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/FindOneNoticeHeader`, body);
    }

    //INTF-00454：根据采购订单行id，获取该行关联的对账单头列表，不分页
    getBillHeaderListByPoLineId(id, route) {
        let body = { types: "object,object", values: [{ po_line_id: id }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseNoticeHeaderProvider/FindNoticeHeaderByPoLineId`, body);
    }

    //INTF-00499：提交一个对账单
    submitBillHeader(id, route) {
        let body = { types: "object,object", values: [{ id: id }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeHeaderProvider/SubmitNoticeHeader`, body);
    }


    //------------------对账通知行相关----------------------------------------//
    //INTF-00082：在对账通知头下，根据提供的收货单行数组arr，在对账单头id下，新建对账通知行
    createBillLineById(arr, id, route) {
        let body = { types: "slice,int,object", values: [{ notice_header_id: id, infos: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeLineProvider/NoticeLineAdd`, body);
    }

    //INTF-00346：保存一条被修改的对账单行内容
    updateBillLine(val, route) {
        let body = { types: "object,object", values: [{ info: val }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeLineProvider/NoticeLineUpdate`, body);
    }


    //INTF-00347：获取对账通知单头下的对账通知行列表
    getReconciliationLineListByHeaderId(query, id, route) {
        let body = { types: "object,object", values: [{ query: query, notice_header_id: id }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeLineProvider/FindAllNoticeLineByHeaderId`, body);
    }


    //INTF-00361：根据供应商用户ID，获取该供应商下的收货行, 暂时不分页
    getReceiveLineBySupplierUserId(id, route) {
        let body = { types: "object,object", values: [{ notice_header_id: id }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeLineProvider/FindGoodsLineByPoHeaderId`, body);
    }

    //INTF-00362：批量删除选中的对账通知单行
    batchDeleteBillLine(hid, arr, route) {
        let body = { types: "object,object", values: [{ notice_header_id: hid, ids: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.SupplierNoticeLineProvider/NoticeLineDeleteByIds`, body);
    }


    //------------------------供应商票据相关---------------------------//
    //INTF-00088：对创建的供应商票据进行保存
    addSupplierInvoice(val) {
        let body = val;
        return axios.post(`/myBillApp/service.BillHeaderProvider/CreateOne`, body);
    }

    //INTF-00089：对选中的票据进行删除
    batchDeleteSupplierInvoice(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myBillApp/service.BillHeaderProvider/Delete`, body);
    }

    //INTF-00090：对供应商票据进行修改保存
    updateSupplierInvoice(val) {
        let body = val;
        return axios.post(`/myBillApp/service.BillHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00091：根据供应商用户ID，分页查询供应商的票据列表
    async getSupplierInvoiceListByUserId(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBillApp/service.BillHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier invoice list failed: INTF-00091", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00502：分页查看或所有票据列表, statsType=3 只查看statu为3的，statsType != 3 查看statu>=3的，
    async getSupplierInvoiceList(query, statusType) {
        let body = { query: query, status_type: statusType };
        try {
            let res = await axios.post(`/myBillApp/service.BillHeaderProvider/FindAllReceived`, body);
            //检查是否是空对象
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，重新包装结果
                res.bill_usage_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier invoice failed: INTF-00502", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00503：根据票据ID，获得票据详情信息
    getSupplierInvoiceDetailById(id) {
        let body = { id: id };
        return axios.post(`/myBillApp/service.BillHeaderProvider/FindOne`, body);
    }

    //INTF-00504：供应商提交票据
    submitSupplierInvoice(val, route) {
        let body = { types: "object,object", values: [{ id: val.id }, utils.getUidAndToken(route)] };
        return axios.post(`/myBillApp/service.BillPurchaseHeaderProvider/SubmitApprove`, body);
    }

    //INTF-00660：获取供应商下草稿且尚未被引入到对账单中的票据列表
    async getDraftSupplierInvoiceListNotInBill(query, related_type) {
        let body = { query: query, related_type: related_type };
        try {
            let res = await axios.post(`/myBillApp/service.BillHeaderProvider/FindAllUnused`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get invoice list not related with bill failed: INTF-00660", err);
            return { err: true, msg: err.response.data };
        }
    }


    //---------------------------供应商对账单，新的模式------------------------//
    //INTF-00632：通过或回退一个对账单头
    approveOrRollbakBillHeader(id, status) {
        let body = { id: id, status: status };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/ConfirmedBySup`, body);
    }

    //INTF-00633：在对账单头下，添加多条票据信息
    batchAddInvoiceInBillHeader(arr, id) {
        let body = { id_arr: arr, header_id: id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/AddBillHeaders`, body);
    }

    //INTF-00634：在对账单头下，移除多条票据信息
    batchRemoveInvoiceInBillHeader(arr, id) {
        let body = { id_arr: arr, header_id: id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/RemoveBillHeaders`, body);
    }

    //INTF-00636：分页查询对账单头下的票据明细
    async getInvoiceListInBillHeaderInPage(bill_header_id) {
        let body = { id: bill_header_id };
        try {
            let res = await axios.post(`/mySupplierApp/service.AccountStatementProvider/FindBillsByHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.bill_purchase_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get invoice list by bill header in pages failed: INTF-00636", err);
            return { err: true, msg: response.data };
        }
    }

    //INTF-00637：对账单的票据进行提交
    submitInvoiceInBillHeader(id, email_address_str) {
        let body = { id: id, email: email_address_str };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/ReleaseBills`, body);
    }

    //INTF-00642：获取供应商用户id所对应的供应商公司下，状态>=2的对账单头列表，分页。
    async getBillHeaderListBySupplierUidInPage(query, arr) {
        query.status = arr;
        let body = query;
        try {
            let res = await axios.post(`/mySupplierApp/service.AccountStatementProvider/FindAllHeadersBySup`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.account_statement_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bill header list in supplier in pages failed: INTF-00642", err);
            return { err: true, msg: response.data };
        }
    }


    //------------------------按格式下载ASN单据，物资卡-----------------------//
    //INTF-00698：按格式下载ASN单据、物资卡
    downloadAsnFormAndContainerLableById(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/DownLoad`, body);
    }


    //-----------------公司间交易用--------------------//
    //INTF-00793：作为卖方公司，查看收到的对账单的列表，分页
    async getInternalTradeBillHeaderListInPage(query, arr) {
        query.status = arr;
        let body = query;
        try {
            let res = await axios.post(`/mySupplierApp/service.AccountStatementProvider/FindForInternal`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.account_statement_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get internal trade bill list failed: INTF-00793", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00798:找到给定的单据所关联的全部票据
    async getInvoiceListByQuery(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBillApp/service.BillHeaderProvider/FindAllRelatedBills`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.bill_usage_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get invoice list by header id failed: INTF-00798", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00796：批量添加票据的使用
    batchAddInvoiceUsage(body) {
        return axios.post(`/myBillApp/service.BillHeaderProvider/AddBillUsage`, body);
    }

    //INTF-00797: 批量移除票据的使用
    batchRemoveInvoiceUsage(body) {
        return axios.post(`/myBillApp/service.BillHeaderProvider/RemoveBillUsage`, body);

    }

    // INTF-00801 :批量导出供应商信息
    batchDownloadSupplierInfo() {
        return axios.post(`/mySupplierApp/service.SupplierProvider/BatchDownload`, {});
    }

    // INTF-00802 :批量导出该公司下的供应商交货单、仅内部用户使用
    batchDownloadSupplierAsnInfo() {
        return axios.post(`/mySupplierApp/service.SupplierAsnHeaderProvider/BatchDownload`, {});
    }

}

export default Supplier;